export const findEntity = (label, entities) => {
  const found = entities.find((e) => e.label === label);
  if (!found) return null;
  return found.value;
};
